module.exports = __webpack_public_path__ + "img/headphones.e91bb7b1.webp";